import { formatDate, formatNumber, TableMeta, useWSysPage, useWSysPath, WSysGrid, WSysPage, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core"
import { useKonyveloApi } from "../store/konyvelo.api";
import { FormControl, FormLabel, GridItem, Input, InputGroup, InputRightElement, Stack } from "@chakra-ui/react";
import { FORG_SOR_PUB_META } from "@coimbra-its/api.konyvelo";

const CELLS_SOROK = new TableMeta(FORG_SOR_PUB_META).forTable();


export function Kiszla({ DOKID }: { DOKID: number }) {


    const path = useWSysPath();
    const pathDetails = path.useChild('details');



    const api = useKonyveloApi();
    const [data, hub] = api.kiszlaIdGet.useData({ DOKID });
    const szamla = data?.szamla || {};
    const sorok = data?.sorok || [];
    const csatolasok = data?.csatolasok || [];


    const page = useWSysPage({ title: data?.szamla.P_NEV || 'Kimenő számla', maxCols: 4, minCols: 2, wsStyle: 'inverted' })


    return <WSysPage page={page} hubs={[hub]}

    >
        <WSysVert mode="static" p={3} pb={0} isInverted={true}>
            <WSysGrid minCols={3} gap={9} p={3} cols={[2, 3]} justifyContent='stretch' autoWrap={false}>
                <GridItem>

                <Stack gap={0}>
						<FormControl>
							<FormLabel color='primary.400'>Számla száma</FormLabel>
							<Input value={szamla.SZLASZ} onChange={() => { }} readOnly={true}
								textAlign='right' variant='flushed' fontSize='xl'
							/>
						</FormControl>

						<FormControl>
							<FormLabel color='primary.400'>Számla dátuma</FormLabel>
							<Input value={formatDate(szamla.ROGZDAT)} onChange={() => { }} readOnly={true}
								textAlign='right' variant='flushed' fontSize='xl'
							/>
						</FormControl>

						<FormControl>
							<FormLabel color='primary.400'>Bruttó összeg</FormLabel>
							<InputGroup
							>
								<Input value={formatNumber(szamla.DEV_BRUTTO, szamla.DEV === 'HUF' ? 0 : 2)} onChange={() => { }} readOnly={true}
									textAlign='right' variant='flushed' fontSize='xl'
								/>
								<InputRightElement fontSize='xl' >&nbsp;{(szamla.DEV === 'HUF' ? 'Ft' : szamla.DEV)}</InputRightElement>
							</InputGroup>
						</FormControl>

						<FormControl>
							<FormLabel color='primary.400'>Nettó összeg</FormLabel>
							<InputGroup
							>
								<Input value={formatNumber(szamla.DEV_NETTO, szamla.DEV === 'HUF' ? 0 : 2)} onChange={() => { }} readOnly={true}
									textAlign='right' variant='flushed' fontSize='3xl'
								/>
								<InputRightElement fontSize='xl' >&nbsp;{(szamla.DEV === 'HUF' ? 'Ft' : szamla.DEV)}</InputRightElement>
							</InputGroup>
						</FormControl>

					</Stack>                    
                </GridItem>
                <GridItem>
                </GridItem>
            </WSysGrid>
        </WSysVert>
        <WSysVert mode='rest'>
            <WSysTable 
                rows={sorok}
                cells={CELLS_SOROK}
            
            />

        </WSysVert>

    </WSysPage>
}